export function isEmailAddress (value) {
  const emailAddressRegex = '[a-zA-Z0-9+._%-+]{1,256}@[a-zA-Z0-9][a-zA-Z0-9-]{0,64}([.][a-zA-Z0-9][a-zA-Z0-9-]{0,25})'
  return new RegExp(emailAddressRegex).test(value)
}
